import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "Ile kosztuje montaż fotowoltaiki dla domu?",
    a: "Typowa instalacja w Polsce kosztuje ok. 20 000 – 45 000 zł brutto, zależnie od mocy, magazynu energii i specyfiki dachu. Dokładną wycenę przygotujemy po rozmowie.",
  },
  {
    q: "Czy konsultacja jest bezpłatna?",
    a: "Tak — rozmowa i pomoc są bezpłatne.",
  },
  {
    q: "Kiedy się ze mną skontaktujecie?",
    a: "Doradca skontaktuje się z Tobą najszybciej, jak to możliwe — zwykle w ciągu 5–10 minut w godzinach 8:00–20:00. Poza tymi godzinami — pierwszej rzeczy następnego dnia.",
  },
  {
    q: "Jak wygląda proces?",
    a: "Zostawiasz numer → oddzwaniamy → dobieramy rozwiązanie → montaż.",
  },
  {
    q: "Czy pomagacie w doborze instalacji?",
    a: "Tak — analizujemy zużycie energii, warunki dachu i nasłonecznienie, a następnie proponujemy moc i konfigurację dopasowaną do Twojego domu.",
  },
];

export default function FAQPrzyklad() {
  return (
    <section id="faq" className="py-16 lg:py-24 bg-brand-surface" data-testid="faq-przyklad-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">FAQ</p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl tracking-tight text-brand-ink">
            Krótko o najważniejszym
          </h2>
        </div>

        <div className="mt-10 bg-white rounded-3xl shadow-sm border border-brand-border p-2 sm:p-4">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="border-b border-brand-border last:border-b-0"
                data-testid={`faq-przyklad-item-${idx}`}
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-base sm:text-lg text-brand-ink hover:text-brand-blue px-4 py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-muted leading-relaxed px-4 pb-5 text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
